import { Box, Button, Card, Typography } from '@mui/joy'
import React from 'react'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import TarifStandViewer from '../TarifStandViewer/TarifStandViewer';
import { post, Token } from '../../../../../Script/Session';
import { useNavigate } from 'react-router-dom';
function LastTarif({ data, setcreate }) {
    const navigate = useNavigate();
    function deletetarif() {
        let body = {};
        body.token = Token.get();
        body.action = "delete_tarif";
        body.targetid = data.id;
        body.subkath = data.subkath;
        let response = post(body, "/tarife/edit_tarif");
        if (response == "LOGOUT") {
            navigate("/");
        }
        if (response == "OK") {
            window.history.back();

        }
    }
    return (
        <>
            {
                data && data.editperms && data.stände.length < 1 ? (
                    <Card variant='soft' sx={{ bgcolor: "#ffcdd2", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <Box>
                            <Typography level="title-md">Keine Tarifstände gefunden!</Typography>
                            <Typography>Keine Tarifstände gefunden bitte erstellen sie einen!</Typography>
                        </Box>
                        <Box sx={{ flexDirection: "row", display: "flex", gap: 2 }}>
                            <Button onClick={() => setcreate(true)} startDecorator={<AddBoxOutlinedIcon />} sx={{ height: "5%" }}>
                                Erstellen
                            </Button>
                            <Button onClick={() => deletetarif()} sx={{ height: "5%" }} color='danger'>Tarif Löschen</Button>
                        </Box>



                    </Card>
                ) : (
                    <TarifStandViewer data={data.lasttarif} fragen={data.fragen} perms={data.editperms} subkath={data.subkath} />



                )
            }

        </>
    )
}

export default LastTarif
